// extracted by mini-css-extract-plugin
module.exports = {"SectionU3":"SectionU3_SectionU3__yYTXA"};